import SeriesData from './SeriesData';

export default SeriesData;
